document.write(
  '<link href = "https://fonts.googleapis.com/icon?family=Material+Icons" rel = "stylesheet"/>'
);

(function($) {
  $(function() {
    $(".sidenav").sidenav();
    $(".parallax").parallax();
  }); // end of document ready
})(jQuery); // end of jQuery name space
